import styled from 'styled-components';
import { LabelRegularBoldM } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface IPageSection {
  theme: ITheme;
  isTitle: boolean;
  isUnstyled: boolean;
  width: 'full' | 'half';
}

export const PageSectionCont = styled.div<IPageSection>`
  width: ${({ width }) => (width === 'full' ? '100%' : '50%')};
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;

  ${({ theme, isTitle, isUnstyled }) => `
    margin: ${isTitle ? theme.layout.spacing.centy : theme.layout.spacing.centy} 0 ${
  theme.layout.spacing.giga
};
    padding: ${isUnstyled ? '0' : `0 0 ${theme.layout.spacing.centy}`};
    box-shadow: ${isUnstyled ? 'none' : `0px 1px 1px ${theme.colors.neutral.primary[40]}`};
    background: ${isUnstyled ? 'transparent' : `${theme.colors.neutral.primary[5]}`};
 `}
`;

export const SectionTitle = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 17px;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[90]};
  `}
`;
